var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-comp"},[_c('div',{staticClass:"modal",style:({'width': '800px', 'height' : '650px'})},[_c('section',{staticClass:"modal-card-body"},[_c('iframe',{attrs:{"src":_vm.iframeUrl,"height":"650px","width":"100%","frameborder":"0"},on:{"load":_vm.frameLoaded}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }